// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"5d63cde3","122":"716da9f2","256":"26522984","398":"19c4dd73","420":"80ddb4e0","662":"9f61b223","700":"ed92128d","844":"f239ba30","902":"140b8b81"}[chunkId] + ".chunk.js";
};